(() => {
  if (window.lfDiscoveryLoaded) return;
  window.lfDiscoveryLoaded = true;
  const script = document.querySelector('script[data-lf-discovery]');
  const root = window.Shopify?.routes?.root || '/';
  if (!customElements.get('lf-cart-preview')) customElements.define('lf-cart-preview', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const options = {signal:this.abort.signal};
      this.refresh = () => { this.hidden=true; clearTimeout(this.timer); this.timer=setTimeout(()=>this.load(),80); };
      document.addEventListener('cart:change',this.refresh,options);
      document.addEventListener('cart:refresh',this.refresh,options);
      window.addEventListener('pageshow',this.refresh,options);
      window.addEventListener('focus',this.refresh,options);
      document.addEventListener('visibilitychange',()=>{if(!document.hidden)this.refresh();},options);
      this.refresh();
    }
    async load() {
      this.request?.abort(); this.request=new AbortController();
      const request=this.request;
      try {
        const url=new URL(root,location.origin);url.searchParams.set('section_id',this.dataset.sectionId);url.searchParams.set('_lf',Date.now());
        const response=await fetch(url,{cache:'no-store',signal:request.signal});if(!response.ok)throw Error('Cart refresh failed');
        const node=new DOMParser().parseFromString(await response.text(),'text/html').querySelector('lf-cart-preview');
        if(!node||request!==this.request||!this.isConnected)return;
        this.replaceChildren(...node.childNodes);this.hidden=node.hidden;
      } catch(error) { if(request===this.request)this.hidden=true; }
    }
    disconnectedCallback(){this.abort?.abort();this.request?.abort();clearTimeout(this.timer);}
  });
  const key='lf_recent_handles_v1';
  const allowed=()=>script?.dataset.historyEnabled==='true'&&window.Shopify?.customerPrivacy?.preferencesProcessingAllowed?.()===true;
  const read=()=>{const parsed=JSON.parse(localStorage.getItem(key)||'[]');return Array.isArray(parsed)?[...new Set(parsed.filter(h=>typeof h==='string'&&/^[a-z0-9-]{1,200}$/.test(h)))].slice(0,6):[];};
  const forget=()=>{try{localStorage.removeItem(key);}catch{}document.querySelectorAll('lf-recently-viewed').forEach(e=>{e.cancel?.();e.hidden=true;e.querySelector('[data-recent-products]')?.replaceChildren();});};
  if(!customElements.get('lf-recently-viewed'))customElements.define('lf-recently-viewed',class extends HTMLElement{
    connectedCallback(){this.render();}
    cancel(){this.request?.abort();}
    async render(){
      this.cancel();this.request=new AbortController();const request=this.request;this.hidden=true;
      if(!allowed())return;
      let handles;try{handles=read().slice(0,Math.min(6,Number(this.dataset.limit)||6));}catch{return;}
      if(!handles.length)return;
      const cards=await Promise.all(handles.map(async handle=>{try{const url=new URL(root+'products/'+encodeURIComponent(handle),location.origin);url.searchParams.set('section_id','lf-recent-card');const r=await fetch(url,{cache:'no-store',signal:request.signal});if(!r.ok)return null;return new DOMParser().parseFromString(await r.text(),'text/html').querySelector('.lf-discovery-card');}catch{return null;}}));
      if(request!==this.request||!this.isConnected||!allowed())return;
      const valid=cards.filter(Boolean);this.querySelector('[data-recent-products]').replaceChildren(...valid);this.hidden=!valid.length;
    }
    disconnectedCallback(){this.cancel();}
  });
  const updateHistory=()=>{
    if(!window.Shopify?.customerPrivacy)return;
    if(!allowed()){forget();return;}
    try {const current=script?.dataset.productHandle;const previous=read();if(current&&/^[a-z0-9-]{1,200}$/.test(current))localStorage.setItem(key,JSON.stringify([current,...previous.filter(h=>h!==current)].slice(0,6)));}
    catch{forget();return;}
    document.querySelectorAll('lf-recently-viewed').forEach(e=>e.render());
  };
  document.addEventListener('visitorConsentCollected',updateHistory);
  window.addEventListener('storage',e=>{if(e.key===key)document.querySelectorAll('lf-recently-viewed').forEach(row=>row.render());});
  window.addEventListener('pageshow',updateHistory);
  if(window.Shopify?.customerPrivacy)updateHistory();
  else if(window.Shopify?.loadFeatures)window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],error=>{if(!error)updateHistory();});
})();
